export class DocumentDTO {
  documentType: string;
  fileName: string;
  fileReferenceType: string;
  fileReferenceValue: string;
}
